import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplateVariablesMutation, UpdateTemplateVariablesMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplateVariablesDocument } from '@/graphql/generated/graphql';
export type TemplateVariableUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  TemplateId?: string
  ParentId?: string
  Token?: string
  Name?: string
  Label?: string
  Type?: string
  Required?: boolean
  Placeholder?: string
  HelpText?: string
  Options?: string[]
  DefaultValue?: string
  Format?: string
  TypeMeta?: string
  Order?: number
  SourceSpan?: string
  UilmLabelKey?: string
  UilmPlaceholderKey?: string
  UilmHelpTextKey?: string
  UilmOptionsKeys?: string[]
}

export type UpdateTemplateVariableResponse = {
  data: {
    updateTemplateVariables: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplateVariable = () => {
  const mutation = useMutation({
    mutationKey: ['update-template-variable'],
    mutationFn: (variables: TemplateVariableUpdateInput) => {
      return graphqlClient.request<UpdateTemplateVariablesMutation>(UpdateTemplateVariablesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplateVariable: mutation.mutate,
    updateTemplateVariableAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_VARIABLE_MUTATION = UpdateTemplateVariablesDocument;
